/* unplugin-vue-components disabled */import { render } from "./ResourceCenter.vue?vue&type=template&id=1f1f69a4&scoped=true"
import script from "./ResourceCenter.vue?vue&type=script&lang=js"
export * from "./ResourceCenter.vue?vue&type=script&lang=js"

import "./ResourceCenter.vue?vue&type=style&index=0&id=1f1f69a4&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1f69a4"]])

export default __exports__